import { ProfileImage } from './ProfileImage'

export { ProfileImage }
